import AbstractTool from "../AbstractTool";
import { DELETE } from "../actions/ActionHelper";
import SelectionMenu from "../SelectionMenu";

export default class EraseTool extends AbstractTool {
    scrollEnabled = true;
    resetPreviousTool = true;
    menu = new SelectionMenu(this.provider, 'edit');

    activate() {
        super.activate();
        this.elements.hovered()
            ? this.cursor.delete()
            : this.cursor.arrow();
    }

    deactivate() {
        super.deactivate();
        this.menu.remove();
    }

    pressMouseOnCanvas() {
        if (this.p.mouseButton === this.p.RIGHT) {
            let hovered = this.elements.hoveredAll();
            if (hovered.length > 1) {
                this.hoverSet.reset();
                this.menu.refresh(hovered, (element) => {
                    this.actions.execute(DELETE, [element]);
                    this.menu.remove();
                    this.cursor.arrow();
                });
            }
        }
    }

    clickMouseOnCanvas() {
        if (this.menu.initialized) {
            this.menu.remove();
            return;
        }
        let hover = this.elements.hovered();
        if (hover) {
            this.actions.execute(DELETE, [hover]);
            this.cursor.arrow();
        }
    }

    moveMouse() {
        let hovered = this.elements.hovered();
        hovered
            ? this.cursor.delete()
            : this.cursor.arrow();
        this.hoverSet.set(hovered);
    }

    getTips() {
        if (this.touch) {
            return "Tap on an element to delete it. Long-press to pick when elements overlap.";
        }
        return "Click on an element to delete it. Right click to select element when they overlap."
    }

    pressKey(code) {
        switch (code) {
            case 27: // Esc
                this.setTool('select');
                break;
            case 37: // left arrow
                this.view.move(this.arrowMove, 0);
                break;
            case 38: // up arrow
                this.view.move(0, this.arrowMove);
                break;
            case 39: // right arrow
                this.view.move(-this.arrowMove, 0);
                break;
            case 40: // down arrow
                this.view.move(0, -this.arrowMove);
                break;
        }
    }
}
